export enum EReminderStage {
  firstReminder = 'firstReminder',
  finalReminder = 'finalReminder',
  lod = 'lod',
}

export enum ReminderSkipTime {
  first = 'first',
  second = 'second',
  final = 'final',
}

export enum EPaymentReminderEmailStatus {
  pending = 'pending',
  sent = 'sent',
  failed = 'failed',
}

export enum EPreLodEmailType {
  firstPreLod = 'firstPreLod',
  secondPreLod = 'secondPreLod',
  thirdPreLod = 'thirdPreLod',
}

export enum EDebtRecoveryOption {
  arbitration = 'arbitration',
  civilClaim = 'civilClaim',
  civilSuit = 'civilSuit',
  debtCollectionAgency = 'debtCollectionAgency',
  enforcementOfJudgment = 'enforcementOfJudgment',
  mediation = 'mediation',
  sctOrder = 'sctOrder',
  smallClaims = 'smallClaims',
}

export enum EWriteOffReason {
  statutoryExpiry = 'statutoryExpiry',
  unableToContact = 'unableToContact',
  others = 'others',
}

export enum EPaymentReminderStatus {
  draft = 'draft',
  firstReminder = 'firstReminder',
  finalReminder = 'finalReminder',
  lod = 'lod',
  debtCollectionAgency = 'debtCollectionAgency',
  mediation = 'mediation',
  arbitration = 'arbitration',
  smallClaims = 'smallClaims',
  civilClaim = 'civilClaim',
  civilSuit = 'civilSuit',
  enforcementOfJudgment = 'enforcementOfJudgment',
  sctOrder = 'sctOrder',
  writeOff = 'writeOff',
}


export enum ELetterBatchStatus {
  queued = 'queued',
  processing = 'processing',
  completed = 'completed',
  partial = 'partial',
  failed = 'failed',
}

export enum ELetterChunkStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
}
